import { createAbstractAnnouncerIntegration } from 'config/platforms/AbstractAnnouncerIntegration';

export const createComcastAnnouncerIntegration = () =>
  class ComcastAnnouncerIntegration extends createAbstractAnnouncerIntegration() {};
